import { useCallback } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import type { Task } from '../../../../types';

export function useGetHref() {
	const { slug } = useKnownAvailableParams<{ slug: string }>();

	return useCallback(
		({ name }: { name: Task['name'] }) => {
			switch (name) {
				case 'promote_basic': {
					return `/p/${slug}/promote`;
				}
				case 'promote_high_performer': {
					return `/p/${slug}/promote`;
				}
				case 'share_supporters': {
					return `/p/${slug}/u/new`;
				}
				default: {
					return undefined;
				}
			}
		},
		[slug],
	);
}
